import { Stack } from "@mantine/core"
import { useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { AgecStatsTable } from "~/pages/Admin/Exports/AgecStats/AgecStatsTable"
import { useFindAllAgecStatsQuery } from "~/pages/Admin/Exports/AgecStats/hooks/useFindAllAgecStatsQuery"

export function AgecStatsContainer() {
  const [groupByCollection, setGroupByCollection] = useState<boolean>(false)

  const query = useFindAllAgecStatsQuery({ groupByCollection })

  return (
    <HeaderControlsProvider>
      <Stack>
        <DataFetchWrapper query={query}>
          {({ data }) => (
            <AgecStatsTable
              agecStats={data.data}
              groupByCollection={groupByCollection}
              setGroupByCollection={setGroupByCollection}
            />
          )}
        </DataFetchWrapper>
      </Stack>
    </HeaderControlsProvider>
  )
}
